import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" {...props}><path d="M7.74 8L0 14.875 1.01 16 10 8 1.01 0 0 1.125z" /></svg>);